module.exports = __webpack_public_path__ + "img/introm.d5411a00.jpg";